import type {
  TableHTMLAttributes,
  HTMLAttributes,
  ThHTMLAttributes,
  TdHTMLAttributes,
} from 'react';
import { cn } from '../lib/cn';
import './Table.css';

export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  /** Envolve em container com scroll horizontal em telas estreitas. */
  scrollable?: boolean;
  /** Abaixo de 640px cada linha vira um CARD e cada célula mostra o rótulo da sua
   *  coluna, lido de `data-label` na própria célula. Opt-in de propósito: em tabela
   *  larga (a de auditoria tem 10 colunas, duas delas hashes) o card fica com uma
   *  linha por coluna e a rolagem horizontal é MENOS ruim. Use em tabelas curtas. */
  cards?: boolean;
}

export function Table({
  scrollable = true,
  cards = false,
  className,
  children,
  ...rest
}: TableProps): JSX.Element {
  const table = (
    <table className={cn('cf-table', cards && 'cf-table--cards', className)} {...rest}>
      {children}
    </table>
  );
  // Em modo card não há o que rolar; a classe no wrapper desliga o overflow sem
  // depender de `:has()`, que nem todo browser de celular em uso resolve.
  return scrollable ? (
    <div className={cn('cf-table__scroll', cards && 'cf-table__scroll--cards')}>{table}</div>
  ) : (
    table
  );
}

export function Thead(props: HTMLAttributes<HTMLTableSectionElement>): JSX.Element {
  return <thead {...props} />;
}
export function Tbody(props: HTMLAttributes<HTMLTableSectionElement>): JSX.Element {
  return <tbody {...props} />;
}
export function Tr(props: HTMLAttributes<HTMLTableRowElement>): JSX.Element {
  return <tr {...props} />;
}

export type ThProps = ThHTMLAttributes<HTMLTableCellElement>;
export function Th({ className, ...rest }: ThProps): JSX.Element {
  return <th className={cn('cf-table__th', className)} {...rest} />;
}

export interface TdProps extends TdHTMLAttributes<HTMLTableCellElement> {
  /** Fonte monoespaçada (IDs, votos, horários). */
  mono?: boolean;
}
export function Td({ mono, className, ...rest }: TdProps): JSX.Element {
  return <td className={cn('cf-table__td', mono && 'cf-table__td--mono', className)} {...rest} />;
}
